import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import {
  ClariStore,
  ProfessionalCredentials,
  ProfessionalCredentialsStore,
} from './types'

export const useClariStore = create<ClariStore>()(
  persist(
    set => {
      return {
        clariIntent: null,
        setClariIntent: (intent: string) => {
          set({ clariIntent: intent })
        },
      }
    },
    {
      name: 'clari',
      getStorage: () => sessionStorage,
    },
  ),
)

export const useProfessionalCredentialsStore =
  create<ProfessionalCredentialsStore>()(
    persist<ProfessionalCredentialsStore>(
      set => ({
        professionalCredentials: {} as ProfessionalCredentials,
        setProfessionalCredentials: data =>
          set({ professionalCredentials: data }),
      }),
      {
        name: 'professional-credentials',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  )
